import PASSIVE_REDUCED_ENERGYCOST from "./assets/spells/PASSIVE_REDUCED_ENERGYCOST.png";
import ENERGYBURST_CHANNEL from "./assets/spells/ENERGYBURST_CHANNEL.png";
import ENERGYFIELD from "./assets/spells/ENERGYFIELD.png";
import PASSIVE_CASTSPEED from "./assets/spells/PASSIVE_CASTSPEED.png";
import SELF_CLEANSE from "./assets/spells/SELF_CLEANSE.png";
import GROWING_RAGE from "./assets/spells/GROWING_RAGE.png";
import PASSIVE_BALANCE from "./assets/spells/PASSIVE_BALANCE.png";
import PASSIVE_INCREASED_AASPEED from "./assets/spells/PASSIVE_INCREASED_AASPEED.png";
import PASSIVE_CD_REDUCTION from "./assets/spells/PASSIVE_CD_REDUCTION.png";
import ENERGIZING_SHIELD from "./assets/spells/Energizing Shield.png";
import force_field from "./assets/spells/Force Field.png";
import aggression from "./assets/spells/Aggression.png";
import Concentration from "./assets/spells/Concentration.png";
import Efficiency from "./assets/spells/Efficiency.png";
import ENERGYSHIELD from "./assets/spells/ENERGYSHIELD2.png";
import Ice_block from "./assets/spells/Ice Block.png";
import Firebreath from "./assets/spells/Firebreath.png";
import Perpetual_energy from "./assets/spells/Perpetual Energy.png";
import Purge from "./assets/spells/Purge.png";
import Inner_Corruption from "./assets/spells/Inner Corruption.png";
import Hyper_Focus from "./assets/spells/Hyper Focus.png";
import Avalonian_beam from "./assets/spells/Avalonian Beam.png";
import Howl from "./assets/spells/Howl.png";
import Balanced_Mind from "./assets/spells/Balanced Mind.png";
import Swiftness from "./assets/spells/Swiftness.png";
import Quick_thinker from "./assets/spells/Quick Thinker.png";
import Retaliate from "./assets/spells/Retaliate.png";
import Growing_rage from "./assets/spells/GROWING_RAGE.png";
import mortal_agony from "./assets/spells/Mortal Agony.png";
import smokebomb from "./assets/spells/Smokebomb.png";
import flash_of_insight from "./assets/spells/Flash of Insight.png";
import Immortal from "./assets/spells/Immortal.png";
import nasty_wounds from "./assets/spells/Nasty Wounds.png";
import stone_skin from "./assets/spells/Stone Skin.png";
import block from "./assets/spells/Block.png";
import toughness from "./assets/spells/Toughness.png";
import authority from "./assets/spells/Authority.png";
import tenacity from "./assets/spells/Tenacity.png";
import displacement_immunity from "./assets/spells/Displacement Immunity.png";
import emergency_shield from "./assets/spells/Emergency Shield.png";
import ballista_support_fire from "./assets/spells/Ballista Support Fire.png";
import sacrifice from "./assets/spells/Sacrifice.png";
import WEAPON_SILENCE from "./assets/spells/WEAPON_SILENCE.png";
import electric_discharge from "./assets/spells/Electric Discharge.png";
import spiders_thread from "./assets/spells/Spiders Thread.png";
import purifying_smoke from "./assets/spells/Purifying Smoke.png";

import OUTOFCOMBATHEAL from "./assets/spells/OUTOFCOMBATHEAL.png";
import Frost_Shield from "./assets/spells/Frost Shield.png";
import Speed_Caster from "./assets/spells/Speed Caster.png";
import Everlasting_Spirit from "./assets/spells/Everlasting Spirit.png";
import Purging_Shield from "./assets/spells/Purging Shield.png";
import Magic_Rune from "./assets/spells/Magic Rune.png";
import Obsessive_Burst from "./assets/spells/Obsessive Burst.png";
import Fear_Aura from "./assets/spells/Fear Aura.png";
import Levitate from "./assets/spells/Levitate.png";
import Wild_Magic from "./assets/spells/Wild Magic.png";
import Energy_Emission from "./assets/spells/Energy Emission.png";
import Bloodlust from "./assets/spells/Bloodlust.png";
import FLAMESHIELD from "./assets/spells/FLAMESHIELD.png";
import HASTE from "./assets/spells/HASTE.png";
import Ambush from "./assets/spells/Ambush.png";
import Royal_Banner from "./assets/spells/Royal Banner.png";
import STORMSHIELD from "./assets/spells/STORMSHIELD.png";
import Life_Steal_Aura from "./assets/spells/Life Steal Aura.png";
import BURNAURA from "./assets/spells/BURNAURA.png";
import MIST_WALKER from "./assets/spells/MIST_WALKER.png";
import Dynamic_Defense from "./assets/spells/Dynamic Defense.png";

import Taunt from "./assets/spells/Taunt.png";
import ENRAGE from "./assets/spells/ENRAGE.png";
import PASSIVE_MR_AR from "./assets/spells/PASSIVE_MR_AR.png";
import PASSIVE_CCDURATION from "./assets/spells/PASSIVE_CCDURATION.png";
import PASSIVE_INCREASED_CCR from "./assets/spells/PASSIVE_INCREASED_CCR.png";

import PASSIVE_PLATEARMOR_HEALTH_REDUCTION from "./assets/spells/PASSIVE_PLATEARMOR_HEALTH_REDUCTION.png";
import PASSIVE_PLATEARMOR_THREATGENERATION from "./assets/spells/PASSIVE_PLATEARMOR_THREATGENERATION.png";

import WINDWALL from "./assets/spells/WINDWALL.png";
import ENFEEBLEAURA from "./assets/spells/ENFEEBLEAURA.png";
import MANADRAIN from "./assets/spells/MANADRAIN.png";
import ARMORCHAIN from "./assets/spells/ARMORCHAIN.png";
import REFLECTAREA from "./assets/spells/REFLECTAREA.png";
import FORCESHIELD from "./assets/spells/FORCESHIELD.png";
import ARMOR_WEB from "./assets/spells/ARMOR_WEB.png";
import REFLECT_CHANNEL from "./assets/spells/REFLECT_CHANNEL.png";

import DODGE from "./assets/spells/DODGE.png";
import SPRINTEOT from "./assets/spells/SPRINTEOT.png";
import CHANNELED_RUN from "./assets/spells/CHANNELED_RUN.png";
import PASSIVE_INCREASED_DAMAGE from "./assets/spells/PASSIVE_INCREASED_DAMAGE.png";
import PASSIVE_MAXLOAD_SHOES from "./assets/spells/PASSIVE_MAXLOAD_SHOES.png";

import BLINK from "./assets/spells/BLINK.png";
import DELAYED_TELEPORT from "./assets/spells/DELAYED_TELEPORT.png";
import GLASS_MOVESPEED from "./assets/spells/GLASS_MOVESPEED.png";
import FROSTWALK from "./assets/spells/FROSTWALK.png";
import SWAP from "./assets/spells/SWAP.png";
import DEMONWALK from "./assets/spells/DEMONWALK.png";
import TRANSLUCENT from "./assets/spells/TRANSLUCENT.png";
import HOVER_SPRINT from "./assets/spells/HOVER_SPRINT.png";
import SPRINT_CD_REDUCTION from "./assets/spells/SPRINT_CD_REDUCTION.png";
import CLEANSE_DASH from "./assets/spells/CLEANSE_DASH.png";
import OVERSPRINT from "./assets/spells/OVERSPRINT.png";
import ASSASSIN_DASH from "./assets/spells/ASSASSIN_DASH.png";
import JUMP from "./assets/spells/JUMP.png";
import DMG_BLINK from "./assets/spells/DMG_BLINK.png";
import DEATHMARK from "./assets/spells/DEATHMARK.png";
import INVISIBLE_WALK from "./assets/spells/INVISIBLE_WALK.png";
import AFTER_IMAGE from "./assets/spells/AFTER_IMAGE.png";
import BLINDSPOT from "./assets/spells/BLINDSPOT.png";
import WANDERLUST from "./assets/spells/Wanderlust.png";
import Rejuvenating_Sprint from "./assets/spells/Rejuvenating Sprint.png";

import CHARGE_SHIELD from "./assets/spells/CHARGE_SHIELD.png";
import MAXHEALTHBUFF from "./assets/spells/MAXHEALTHBUFF.png";
import BATTLEFRENZY from "./assets/spells/BATTLEFRENZY.png";
import ROYAL_MARCH from "./assets/spells/ROYAL_MARCH.png";
import BERSERK_SPRINT from "./assets/spells/BERSERK_SPRINT.png";
import SHOULDERTACKLE from "./assets/spells/SHOULDERTACKLE.png";
import CHARGE_IN from "./assets/spells/CHARGE_IN.png";
import CC_BLOCK from "./assets/spells/CC_BLOCK.png";

import Fire_Bolt from "./assets/spells/Fire_Bolt.png";
import BurningField from "./assets/spells/BurningField.png";
import FlameBlast from "./assets/spells/FlameBlast.png";
import SearingFlame from "./assets/spells/SearingFlame.png";
import WallofFlames from "./assets/spells/WallofFlames.png";
import RagingFlare from "./assets/spells/RagingFlare.png";
import FireWave from "./assets/spells/FireWave.png";
import FireArtillery from "./assets/spells/FireArtillery.png";
import Pyroblast from "./assets/spells/Pyroblast.png";
import PASSIVE_BURN from "./assets/spells/PASSIVE_BURN.png";
import PASSIVE_ENERGYCHANCE_FIRESTAFF from "./assets/spells/PASSIVE_ENERGYCHANCE_FIRESTAFF.png";
import PASSIVE_CASTINGSPEED_CHANCE_FIRESTAFF from "./assets/spells/PASSIVE_CASTINGSPEED_CHANCE_FIRESTAFF.png";
import PASSIVE_SPELLPOWER_CASTER_FIRESTAFF from "./assets/spells/PASSIVE_SPELLPOWER_CASTER_FIRESTAFF.png";

import FIREPHOENIX from "./assets/spells/FIREPHOENIX.png";
import FLAMEDASH from "./assets/spells/FLAMEDASH.png";
import FLAMEPILLAR from "./assets/spells/FLAMEPILLAR.png";
import FLAMETORNADO from "./assets/spells/FLAMETORNADO.png";
import HUMAN_TORCH from "./assets/spells/HUMAN_TORCH.png";
import MAGMASPHERE from "./assets/spells/MAGMASPHERE.png";
import METEOR from "./assets/spells/METEOR.png";

import GENEROUSHEAL from "./assets/spells/GENEROUSHEAL.png";
import SMITE_AOE from "./assets/spells/SMITE_AOE.png";
import HOLYFLASH from "./assets/spells/HOLYFLASH.png";
import PULSINGHEAL from "./assets/spells/PULSINGHEAL.png";
import HEALINGBEAM from "./assets/spells/HEALINGBEAM.png";
import HOLYHOT from "./assets/spells/HOLYHOT.png";
import HOLYORB from "./assets/spells/HOLYORB.png";
import RESURRECTION from "./assets/spells/RESURRECTION.png";
import HOLYDESPERATEPRAYER2 from "./assets/spells/HOLYDESPERATEPRAYER2.png";
import PASSIVE_HEALPOWERCHANCE from "./assets/spells/PASSIVE_HEALPOWERCHANCE.png";
import PASSIVE_ENERGYCHANCE_HOLYSTAFF from "./assets/spells/PASSIVE_ENERGYCHANCE_HOLYSTAFF.png";
import PASSIVE_KNOCKBACK_CASTER_HOLYSTAFF from "./assets/spells/PASSIVE_KNOCKBACK_CASTER_HOLYSTAFF.png";
import PASSIVE_HOLY_ASCENDED from "./assets/spells/PASSIVE_HOLY_ASCENDED.png";

import HOLYEXPLOSION from "./assets/spells/HOLYEXPLOSION.png";
import HOLYSHIELD from "./assets/spells/HOLYSHIELD.png";
import HOLYTOUCH from "./assets/spells/HOLYTOUCH.png";
import HOLY_ULTIMATE from "./assets/spells/HOLY_ULTIMATE.png";
import CELESTIAL_SPHERE from "./assets/spells/CELESTIAL_SPHERE.png";
import DIVINE_JUMP from "./assets/spells/DIVINE_JUMP.png";
import HOLY_DISPEL from "./assets/spells/HOLY_DISPEL.png";

import ARCANE_METEOR from "./assets/spells/ARCANE_METEOR.png";
import ARCANECORRIDOR from "./assets/spells/ARCANECORRIDOR.png";
import BLACKHOLE from "./assets/spells/BLACKHOLE.png";
import INVULNERABILITY from "./assets/spells/INVULNERABILITY.png";
import PASSIVE_ARMOR_CASTER_ARCANESTAFF from "./assets/spells/PASSIVE_ARMOR_CASTER_ARCANESTAFF.png";
import PASSIVE_SILENCECHANCE from "./assets/spells/PASSIVE_SILENCECHANCE.png";
import STARFALL_DOT from "./assets/spells/STARFALL_DOT.png";
import TIME_FREEZE from "./assets/spells/TIME_FREEZE.png";
import VOID from "./assets/spells/VOID.png";
import ARCANEORB2 from "./assets/spells/ARCANEORB2.png";
import EMPOWERBEAM from "./assets/spells/EMPOWERBEAM.png";
import FRAZZLE2 from "./assets/spells/FRAZZLE2.png";
import MIMIC from "./assets/spells/MIMIC.png";
import PASSIVE_ATTACKBUFF_ARCANESTAFF from "./assets/spells/PASSIVE_ATTACKBUFF_ARCANESTAFF.png";
import PASSIVE_ENERGYCHANCE_ARCANESTAFF from "./assets/spells/PASSIVE_ENERGYCHANCE_ARCANESTAFF.png";
import ARCANE_CHAIN_MISSILE from "./assets/spells/ARCANE_CHAIN_MISSILE.png";
import CLEANSESPEED2 from "./assets/spells/CLEANSESPEED2.png";
import ENIGMA_BLADE from "./assets/spells/ENIGMA_BLADE.png";
import MAGICSHOCK from "./assets/spells/MAGICSHOCK.png";
import SHIELDFRIENDLY from "./assets/spells/SHIELDFRIENDLY.png";

import FREEZINGWIND from "./assets/spells/FREEZINGWIND.png";
import FROST_BITE from "./assets/spells/FROST_BITE.png";
import FROST_LANCE from "./assets/spells/FROST_LANCE.png";
import HAIL_MULTI_1 from "./assets/spells/HAIL_MULTI_1.png";
import ICE_SCULPTURE from "./assets/spells/ICE_SCULPTURE.png";
import ICESHARD from "./assets/spells/ICESHARD.png";
import ICESTORM2 from "./assets/spells/ICESTORM2.png";
import PASSIVE_SPELLPOWER_CASTER_FROSTSTAFF from "./assets/spells/PASSIVE_SPELLPOWER_CASTER_FROSTSTAFF.png";
import SHATTER_Q from "./assets/spells/SHATTER_Q.png";
import FROST_TARGETED_CHANNEL from "./assets/spells/FROST_TARGETED_CHANNEL.png";
import FROST_ULTIMATE from "./assets/spells/FROST_ULTIMATE.png";
import FROZEN_CRYSTAL from "./assets/spells/FROZEN_CRYSTAL.png";
import GLACIALFIELD from "./assets/spells/GLACIALFIELD.png";
import ICEROCK_EXPLODE from "./assets/spells/ICEROCK_EXPLODE.png";
import FROSTBEAM from "./assets/spells/FROSTBEAM.png";
import FROSTBOMB_CASTSLOW from "./assets/spells/FROSTBOMB_CASTSLOW.png";
import FROSTNOVA from "./assets/spells/FROSTNOVA.png";
import PASSIVE_CASTINGSPEED_CHANCE_FROSTSTAFF from "./assets/spells/PASSIVE_CASTINGSPEED_CHANCE_FROSTSTAFF.png";
import PASSIVE_ENERGYCHANCE_FROSTSTAFF from "./assets/spells/PASSIVE_ENERGYCHANCE_FROSTSTAFF.png";
import PASSIVE_FROST from "./assets/spells/PASSIVE_FROST.png";

import DARKMATTER from "./assets/spells/DARKMATTER.png";
import DEATHCURSE2 from "./assets/spells/DEATHCURSE2.png";
import PASSIVE_CURSE from "./assets/spells/PASSIVE_CURSE.png";
import PASSIVE_ENERGYCHANCE_CURSEDSTAFF from "./assets/spells/PASSIVE_ENERGYCHANCE_CURSEDSTAFF.png";
import PASSIVE_MOVESPEED_CHANCE_CURSEDSTAFF from "./assets/spells/PASSIVE_MOVESPEED_CHANCE_CURSEDSTAFF.png";
import PASSIVE_SPELLPOWER_CASTER_CURSEDSTAFF from "./assets/spells/PASSIVE_SPELLPOWER_CASTER_CURSEDSTAFF.png";
import ARMORPIERCER from "./assets/spells/ARMORPIERCER.png";
import CURSEDBEAM from "./assets/spells/CURSEDBEAM.png";
import CURSEDHANDS_STACKUP from "./assets/spells/CURSEDHANDS_STACKUP.png";
import CURSENOVA from "./assets/spells/CURSENOVA.png";
import CURSED_SPLAT from "./assets/spells/CURSED_SPLAT.png";
import CURSEBLADE from "./assets/spells/CURSEBLADE.png";
import CURSEDOT from "./assets/spells/CURSEDOT.png";
import AREAOFDECAY from "./assets/spells/AREAOFDECAY.png";
import CURSE_SKELETON_BARF_FDHR from "./assets/spells/CURSE_SKELETON_BARF_FDHR.png";
import CURSEULTIMATE from "./assets/spells/CURSEULTIMATE.png";
import DYNAMIC_CURSE from "./assets/spells/DYNAMIC_CURSE.png";
import ENFEEBLEBLADES from "./assets/spells/ENFEEBLEBLADES.png";
import CURSED_WALL from "./assets/spells/CURSED_WALL.png";
import SKULLCURSE from "./assets/spells/SKULLCURSE.png";
import BURNINGARROWS from "./assets/spells/BURNINGARROWS.png";
import DEADLYSHOT from "./assets/spells/DEADLYSHOT.png";
import GROUNDARROW from "./assets/spells/GROUNDARROW.png";
import JUMPSHOT2 from "./assets/spells/JUMPSHOT2.png";
import MULTISHOT2 from "./assets/spells/MULTISHOT2.png";
import PASSIVE_ARMOR_PIERCE_STACK from "./assets/spells/PASSIVE_ARMOR_PIERCE_STACK.png";
import PASSIVE_ENERGYCHANCE_BOW from "./assets/spells/PASSIVE_ENERGYCHANCE_BOW.png";
import PASSIVE_SLOWPOISON from "./assets/spells/PASSIVE_SLOWPOISON.png";
import POISONARROW from "./assets/spells/POISONARROW.png";
import SPEEDARCHER_KITE from "./assets/spells/SPEEDARCHER_KITE.png";
import AIR_RAID from "./assets/spells/AIR_RAID.png";
import ARROWRAIN from "./assets/spells/ARROWRAIN.png";
import HAWK_SHOT_MULTI1 from "./assets/spells/HAWK_SHOT_MULTI1.png";
import HELL_ARROW from "./assets/spells/HELL_ARROW.png";
import LIGHTNING_ARROW from "./assets/spells/LIGHTNING_ARROW.png";
import PASSIVE_AASPEEDCHANCE_BOW from "./assets/spells/PASSIVE_AASPEEDCHANCE_BOW.png";
import SKILLSHOT_STUN from "./assets/spells/SKILLSHOT_STUN.png";
import UNDEADARROWS from "./assets/spells/UNDEADARROWS.png";
import SPEEDSHOT2 from "./assets/spells/SPEEDSHOT2.png";

import QDASH from "./assets/spells/QDASH.png";
import SUNDERARMOR2 from "./assets/spells/SUNDERARMOR2.png";
import ASSASSINSPIRIT from "./assets/spells/ASSASSINSPIRIT.png";
import THROWINGBLADES from "./assets/spells/THROWINGBLADES.png";
import GROUNDDASH from "./assets/spells/GROUNDDASH.png";
import DEEPCUTS from "./assets/spells/DEEPCUTS.png";
import SKILLSHOT_TELEPORT from "./assets/spells/SKILLSHOT_TELEPORT.png";
import CHAINDASH from "./assets/spells/CHAINDASH.png";
import BLOODTHIRSTYBLADE from "./assets/spells/BLOODTHIRSTYBLADE.png";
import PASSIVE_BLEEDCHANCE from "./assets/spells/PASSIVE_BLEEDCHANCE.png";
import PASSIVE_HEALTHCHANCE_DAGGER from "./assets/spells/PASSIVE_HEALTHCHANCE_DAGGER.png";
import PASSIVE_AASPEEDCHANCE_DAGGER from "./assets/spells/PASSIVE_AASPEEDCHANCE_DAGGER.png";
import PASSIVE_SPELLPOWER_CHANCE_DAGGER from "./assets/spells/PASSIVE_SPELLPOWER_CHANCE_DAGGER.png";
import DISEMBOWEL from "./assets/spells/DISEMBOWEL.png";
import RAPIERSTAB from "./assets/spells/RAPIERSTAB.png";
import BLOOD_BLADE from "./assets/spells/BLOOD_BLADE.png";
import GHOSTSTRIKE from "./assets/spells/GHOSTSTRIKE.png";
import BACK_SLASH from "./assets/spells/BACK_SLASH.png";
import EXECUTEDAGGER from "./assets/spells/EXECUTEDAGGER.png";
import CRYSTAL_DAGGER_BLADE_RING from "./assets/spells/CRYSTAL_DAGGER_BLADE_RING.png";

import SPEAR_LUNGE from "./assets/spells/SPEAR_LUNGE.png";
import SPIRITSPEAR from "./assets/spells/SPIRITSPEAR.png";
import FORESTOFSPEARS from "./assets/spells/FORESTOFSPEARS.png";
import CHARGINGBLADE from "./assets/spells/CHARGINGBLADE.png";
import LEGBREAKER from "./assets/spells/LEGBREAKER.png";
import DEFLECTINGSTANCE from "./assets/spells/DEFLECTINGSTANCE.png";
import GROUNDSPEAR from "./assets/spells/GROUNDSPEAR.png";
import SKILLSHOT_PULL from "./assets/spells/SKILLSHOT_PULL.png";
import DASHDMG from "./assets/spells/DASHDMG.png";
import PASSIVE_HEALTHCHANCE_SPEAR from "./assets/spells/PASSIVE_HEALTHCHANCE_SPEAR.png";
import PASSIVE_SPELLPOWER_CHANCE_SPEAR from "./assets/spells/PASSIVE_SPELLPOWER_CHANCE_SPEAR.png";
import PASSIVE_AASPEEDCHANCE_SPEAR from "./assets/spells/PASSIVE_AASPEEDCHANCE_SPEAR.png";
import HALBERDSMASH from "./assets/spells/HALBERDSMASH.png";
import SHOVEL from "./assets/spells/SHOVEL.png";
import TAINTED_STEEL from "./assets/spells/TAINTED_STEEL.png";
import SPEARTHROW from "./assets/spells/SPEARTHROW.png";
import TRIDENTTHROW from "./assets/spells/TRIDENTTHROW.png";
import LANCE_CHARGE from "./assets/spells/LANCE_CHARGE.png";
import SPEAR_AOE_FINISHER from "./assets/spells/SPEAR_AOE_FINISHER.png";

import CONCUSSIVEBLOW_MULTI_1 from "./assets/spells/CONCUSSIVEBLOW_MULTI_1.png";
import WHIRLING_STAFF from "./assets/spells/WHIRLING_STAFF.png";
import CARTWHEEL from "./assets/spells/CARTWHEEL.png";
import QSTAFF_COMBO from "./assets/spells/QSTAFF_COMBO.png";
import STUNRUN from "./assets/spells/STUNRUN.png";
import QS_WHIRLWIND2 from "./assets/spells/QS_WHIRLWIND2.png";
import LAUNCHER from "./assets/spells/LAUNCHER.png";
import SEPARATING_SLAM from "./assets/spells/SEPARATING_SLAM.png";
import VAULT_ATTACK from "./assets/spells/VAULT_ATTACK.png";
import PASSIVE_STUNCHANCE_QUARTERSTAFF from "./assets/spells/PASSIVE_STUNCHANCE_QUARTERSTAFF.png";
import PASSIVE_ENERGYCHANCE_QUARTERSTAFF from "./assets/spells/PASSIVE_ENERGYCHANCE_QUARTERSTAFF.png";
import PASSIVE_HEALTHCHANCE_QUARTERSTAFF from "./assets/spells/PASSIVE_HEALTHCHANCE_QUARTERSTAFF.png";
import PASSIVE_CCDURATION_CHANCE_QUARTERSTAFF from "./assets/spells/PASSIVE_CCDURATION_CHANCE_QUARTERSTAFF.png";

import QSWHIRLWIND from "./assets/spells/QSWHIRLWIND.png";
import DASH_KNOCKBACK from "./assets/spells/DASH_KNOCKBACK.png";
import COMBATSTAFF_SLASH from "./assets/spells/COMBATSTAFF_SLASH.png";
import TORNADO from "./assets/spells/TORNADO.png";
import QS_SLOWROPE from "./assets/spells/QS_SLOWROPE.png";
import SOULSHAKER from "./assets/spells/SOULSHAKER.png";
import QS_CRYSTAL_COMBO from "./assets/spells/QS_CRYSTAL_COMBO.png";

import SHAPE_Q_CAST from "./assets/spells/SHAPE_Q_CAST.png";
import SHAPE_Q_SKILLSHOT from "./assets/spells/SHAPE_Q_SKILLSHOT.png";
import SHAPE_Q_DAMAGE_AND_SHIELD from "./assets/spells/SHAPE_Q_DAMAGE_AND_SHIELD.png";
import SHAPE_Q_CONE_MELEE from "./assets/spells/SHAPE_Q_CONE_MELEE.png";
import SHAPE_W_DAMAGE_AOE from "./assets/spells/SHAPE_W_DAMAGE_AOE.png";
import SHAPE_W_TETHERBEAM from "./assets/spells/SHAPE_W_TETHERBEAM.png";
import SHAPE_W_AREA_PULL from "./assets/spells/SHAPE_W_AREA_PULL.png";
import SHAPE_W_POLYMORPH from "./assets/spells/SHAPE_W_POLYMORPH.png";
import SHAPESHIFT_PANTHER from "./assets/spells/SHAPESHIFT_PANTHER.png";
import PASSIVE_SHAPESHIFT_ATTACK_BUFF from "./assets/spells/PASSIVE_SHAPESHIFT_ATTACK_BUFF.png";
import PASSIVE_SHAPESHIFT_Q_CAST_DAMAGE_REDUCE from "./assets/spells/PASSIVE_SHAPESHIFT_Q_CAST_DAMAGE_REDUCE.png";
import PASSIVE_SHAPESHIFT_GATHER_CHARGES from "./assets/spells/PASSIVE_SHAPESHIFT_GATHER_CHARGES.png";
import PASSIVE_SHAPESHIFT_W_CAST_SPEED_BUFF from "./assets/spells/PASSIVE_SHAPESHIFT_W_CAST_SPEED_BUFF.png";
import SHAPESHIFT_ENT from "./assets/spells/SHAPESHIFT_ENT.png";
import SHAPESHIFT_BEAR from "./assets/spells/SHAPESHIFT_BEAR.png";
import SHAPESHIFT_WEREWOLF from "./assets/spells/SHAPESHIFT_WEREWOLF.png";
import SHAPESHIFT_IMP from "./assets/spells/SHAPESHIFT_IMP.png";
import SHAPESHIFT_ROCK_ELEMENTAL from "./assets/spells/SHAPESHIFT_ROCK_ELEMENTAL.png";
import SHAPESHIFT_AVALONIAN_EAGLE from "./assets/spells/SHAPESHIFT_AVALONIAN_EAGLE.png";
import CrystalCobraTransformation from "./assets/spells/CrystalCobraTransformation.png";

import REJUVENATION from "./assets/spells/REJUVENATION.png";
import THORNSAREA from "./assets/spells/THORNSAREA.png";
import REJUVMUSHROOM_GRENADE from "./assets/spells/REJUVMUSHROOM_GRENADE.png";
import BRAMBLESEED from "./assets/spells/BRAMBLESEED.png";
import REANIMATE from "./assets/spells/REANIMATE.png";
import NATURERESILIENCE from "./assets/spells/NATURERESILIENCE.png";
import CLEANSEHEAL from "./assets/spells/CLEANSEHEAL.png";
import REJUVENATING_BREEZE from "./assets/spells/REJUVENATING_BREEZE.png";
import CIRCLEOFLIFE from "./assets/spells/CIRCLEOFLIFE.png";
import PASSIVE_ENERGYCHANCE_NATURESTAFF from "./assets/spells/PASSIVE_ENERGYCHANCE_NATURESTAFF.png";
import PASSIVE_ARMOR_CASTER_NATURESTAFF from "./assets/spells/PASSIVE_ARMOR_CASTER_NATURESTAFF.png";
import PASSIVE_MOVESPEED_CHANCE_NATURESTAFF from "./assets/spells/PASSIVE_MOVESPEED_CHANCE_NATURESTAFF.png";
import BRIEROFLIFE from "./assets/spells/BRIEROFLIFE.png";
import WELLOFLIFE2 from "./assets/spells/WELLOFLIFE2.png";
import NATURE_ULTIMATE_SINGLE from "./assets/spells/NATURE_ULTIMATE_SINGLE.png";
import ROTTENVINES from "./assets/spells/ROTTENVINES.png";
import SPIRITANIMAL from "./assets/spells/SPIRITANIMAL.png";
import SOUL_LINK from "./assets/spells/SOUL_LINK.png";
import DUAL_NATURE from "./assets/spells/DUAL_NATURE.png";

import HEROICSTRIKE2 from "./assets/spells/HEROICSTRIKE2.png";
import CLEAVE from "./assets/spells/CLEAVE.png";
import SWORD_SPIN from "./assets/spells/SWORD_SPIN.png";
import INTERRUPT2 from "./assets/spells/INTERRUPT2.png";
import SPLITTINGSLASH from "./assets/spells/SPLITTINGSLASH.png";
import HAMSTRINGSWORD from "./assets/spells/HAMSTRINGSWORD.png";
import PARRY from "./assets/spells/PARRY.png";
import DEFENSERUN from "./assets/spells/DEFENSERUN.png";
import MIGHTYBLOW from "./assets/spells/MIGHTYBLOW.png";
import PASSIVE_REDUCE_DMG_SWORD from "./assets/spells/PASSIVE_REDUCE_DMG_SWORD.png";
import PASSIVE_HEROICSTACK from "./assets/spells/PASSIVE_HEROICSTACK.png";
import PASSIVE_ARMORCHANCE_SWORD from "./assets/spells/PASSIVE_ARMORCHANCE_SWORD.png";
import CLAYMORECHARGE from "./assets/spells/CLAYMORECHARGE.png";
import SPINATTACK from "./assets/spells/SPINATTACK.png";
import MIGHTYSWING from "./assets/spells/MIGHTYSWING.png";
import CLAYMORESLASH from "./assets/spells/CLAYMORESLASH.png";
import BLADE_AREA from "./assets/spells/BLADE_AREA.png";
import MAJESTIC_SMASH from "./assets/spells/MAJESTIC_SMASH.png";
import SWORD_BERSERK_RUN_RE from "./assets/spells/SWORD_BERSERK_RUN_RE.png";

import RENDINGSTRIKE from "./assets/spells/RENDINGSTRIKE.png";
import RENDINGSPIN from "./assets/spells/RENDINGSPIN.png";
import RENDINGCOMBO from "./assets/spells/RENDINGCOMBO.png";
import AXESMASH from "./assets/spells/AXESMASH.png";
import AXEBOOST from "./assets/spells/AXEBOOST.png";
import AXE_CHARGE from "./assets/spells/AXE_CHARGE.png";
import INNERBLEEDING from "./assets/spells/INNERBLEEDING.png";
import BLADE_AURA from "./assets/spells/BLADE_AURA.png";
import AXETHROW from "./assets/spells/AXETHROW.png";
import PASSIVE_HEALTHCHANCE_AXE from "./assets/spells/PASSIVE_HEALTHCHANCE_AXE.png";
import PASSIVE_ARMORCHANCE_AXE from "./assets/spells/PASSIVE_ARMORCHANCE_AXE.png";
import PASSIVE_SPELLPOWER_CHANCE_AXE from "./assets/spells/PASSIVE_SPELLPOWER_CHANCE_AXE.png";
import AXEWHIRLWIND2 from "./assets/spells/AXEWHIRLWIND2.png";
import RENDINGSWING from "./assets/spells/RENDINGSWING.png";
import SHOCKWAVE from "./assets/spells/SHOCKWAVE.png";
import SCYTHESWING from "./assets/spells/SCYTHESWING.png";
import DUALAXE_CRAWLER from "./assets/spells/DUALAXE_CRAWLER.png";
import LETHAL_CLEAVER from "./assets/spells/LETHAL_CLEAVER.png";
import CRYSTAL_SCYTHE_DASH_ZONE from "./assets/spells/CRYSTAL_SCYTHE_DASH_ZONE.png";

import DEFENSIVESLAM from "./assets/spells/DEFENSIVESLAM.png";
import THREATENINGSMASH from "./assets/spells/THREATENINGSMASH.png";
import SACRED_GROUND from "./assets/spells/SACRED_GROUND.png";
import GROUNDSHAKER from "./assets/spells/GROUNDSHAKER.png";
import CHARGE_ROOT from "./assets/spells/CHARGE_ROOT.png";
import GUARDRUNE from "./assets/spells/GUARDRUNE.png";
import PBAOE_PULL from "./assets/spells/PBAOE_PULL.png";
import MACELEAP from "./assets/spells/MACELEAP.png";
import PASSIVE_STUNCHANCE from "./assets/spells/PASSIVE_STUNCHANCE.png";
import PASSIVE_ENERGYCHANCE_MACE from "./assets/spells/PASSIVE_ENERGYCHANCE_MACE.png";
import PASSIVE_HEALTHCHANCE_MACE from "./assets/spells/PASSIVE_HEALTHCHANCE_MACE.png";
import PASSIVE_CCDURATION_CHANCE_MACE from "./assets/spells/PASSIVE_CCDURATION_CHANCE_MACE.png";
import SHRIEKMACE from "./assets/spells/SHRIEKMACE.png";
import ROOTFIELD from "./assets/spells/ROOTFIELD.png";
import PRIMALSLAM from "./assets/spells/PRIMALSLAM.png";
import SHRINKINGSMASH from "./assets/spells/SHRINKINGSMASH.png";
import BLESSED_MACES from "./assets/spells/BLESSED_MACES.png";
import VACUUMSLASH from "./assets/spells/VACUUMSLASH.png";
import MACE_CRYSTAL_FRAGMENT_STORM from "./assets/spells/MACE_CRYSTAL_FRAGMENT_STORM.png";

import HAMMER_SHOVE from "./assets/spells/HAMMER_SHOVE.png";
import THREATENINGSTRIKE_HAMMER from "./assets/spells/THREATENINGSTRIKE_HAMMER.png";
import IRONBREAKER from "./assets/spells/IRONBREAKER.png";
import HAMMER_TREMOR from "./assets/spells/HAMMER_TREMOR.png";
import CHARGESLOWAE from "./assets/spells/CHARGESLOWAE.png";
import GEYSER from "./assets/spells/GEYSER.png";
import KNOCKOUT from "./assets/spells/KNOCKOUT.png";
import TAR_RING from "./assets/spells/TAR_RING.png";
import HAMMERWHIRLWIND2 from "./assets/spells/HAMMERWHIRLWIND2.png";
import PASSIVE_ENERGYCHANCE_HAMMER from "./assets/spells/PASSIVE_ENERGYCHANCE_HAMMER.png";
import PASSIVE_HEALTHCHANCE_HAMMER from "./assets/spells/PASSIVE_HEALTHCHANCE_HAMMER.png";
import PASSIVE_CCDURATION_CHANCE_HAMMER from "./assets/spells/PASSIVE_CCDURATION_CHANCE_HAMMER.png";
import GROUNDBREAKER2 from "./assets/spells/GROUNDBREAKER2.png";
import HAMMERTACKLE from "./assets/spells/HAMMERTACKLE.png";
import UNDEADHAND from "./assets/spells/UNDEADHAND.png";
import GIANTSTEPS from "./assets/spells/GIANTSTEPS.png";
import RAM_CHARGE from "./assets/spells/RAM_CHARGE.png";
import SPINNING_SMASH from "./assets/spells/SPINNING_SMASH.png";
import CRYSTALWAVE from "./assets/spells/CRYSTALWAVE.png";

import CREATE_OPENING from "./assets/spells/CREATE_OPENING.png";
import DASHKICK from "./assets/spells/DASHKICK.png";
import CROSSSTEP_ROUNDHOUSE from "./assets/spells/CROSSSTEP_ROUNDHOUSE.png";
import SHOCKWAVE_PUNCH from "./assets/spells/SHOCKWAVE_PUNCH.png";
import TRIPLE_KICK from "./assets/spells/TRIPLE_KICK.png";
import BACKHAND_KNOCKBACK from "./assets/spells/BACKHAND_KNOCKBACK.png";
import KNUCKLE_COUNTER from "./assets/spells/KNUCKLE_COUNTER.png";
import KNUCKLECOMBO from "./assets/spells/KNUCKLECOMBO.png";
import BLAZING_GEYSER from "./assets/spells/BLAZING_GEYSER.png";
import PASSIVE_KNUCKLE_BRAWLER from "./assets/spells/PASSIVE_KNUCKLE_BRAWLER.png";
import PASSIVE_KNUCKLE_RAGE from "./assets/spells/PASSIVE_KNUCKLE_RAGE.png";
import PASSIVE_KNUCKLE_RUSHDOWN from "./assets/spells/PASSIVE_KNUCKLE_RUSHDOWN.png";
import PASSIVE_KNUCKLE_COMBOBREAKER from "./assets/spells/PASSIVE_KNUCKLE_COMBOBREAKER.png";
import DIVEPUNCH_RISE from "./assets/spells/DIVEPUNCH_RISE.png";
import IMPULSE_PUNCH from "./assets/spells/IMPULSE_PUNCH.png";
import PUMMELING_STRIKES from "./assets/spells/PUMMELING_STRIKES.png";
import BOULDER_TOSS from "./assets/spells/BOULDER_TOSS.png";
import GROWING_PUNCH from "./assets/spells/GROWING_PUNCH.png";
import TRIPLECOMBO_DIVEKICK from "./assets/spells/TRIPLECOMBO_DIVEKICK.png";
import CONEPUNCH2 from "./assets/spells/CONEPUNCH2.png";

import AUTOFIRE2 from "./assets/spells/AUTOFIRE2.png";
import BOLTSHOT from "./assets/spells/BOLTSHOT.png";
import KNOCKBACKSHOT2 from "./assets/spells/KNOCKBACKSHOT2.png";
import SUNDERSHOT from "./assets/spells/SUNDERSHOT.png";
import CALTROPS from "./assets/spells/CALTROPS.png";
import SILENCINGBOLT from "./assets/spells/SILENCINGBOLT.png";
import SNIPESHOT_CROSSBOW from "./assets/spells/SNIPESHOT_CROSSBOW.png";
import PASSIVE_KNOCKBACKCHANCE from "./assets/spells/PASSIVE_KNOCKBACKCHANCE.png";
import PASSIVE_CD_RESET_Q from "./assets/spells/PASSIVE_CD_RESET_Q.png";
import PASSIVE_ENERGYCHANCE_CROSSBOW from "./assets/spells/PASSIVE_ENERGYCHANCE_CROSSBOW.png";
import PASSIVE_SPELLPOWER_CASTER_CROSSBOW from "./assets/spells/PASSIVE_SPELLPOWER_CASTER_CROSSBOW.png";
import CROSSBOW_ARMORPIERCER from "./assets/spells/CROSSBOW_ARMORPIERCER.png";
import EXPLODING_SHOT from "./assets/spells/EXPLODING_SHOT.png";
import GROUNDMINE from "./assets/spells/GROUNDMINE.png";
import DUAL_RAPIDFIRE from "./assets/spells/DUAL_RAPIDFIRE.png";
import CROSSBOW_CONE_ULTIMATE from "./assets/spells/CROSSBOW_CONE_ULTIMATE.png";
import CROSSBOW_DIVINE_SHOT from "./assets/spells/CROSSBOW_DIVINE_SHOT.png";
import CRYSTALXBOW from "./assets/spells/CRYSTALXBOW.png";

const spellIcons = {
  PASSIVE_REDUCED_ENERGYCOST,
  SPEAR_AOE_FINISHER,
  PASSIVE_SPELLPOWER_CASTER_CROSSBOW,
  BOLTSHOT,
  TAR_RING,
  PASSIVE_KNOCKBACKCHANCE,
  CALTROPS,
  CONEPUNCH2,
  GROWING_PUNCH,
  GROUNDMINE,
  CROSSBOW_CONE_ULTIMATE,
  DUAL_RAPIDFIRE,
  CROSSBOW_DIVINE_SHOT,
  EXPLODING_SHOT,
  CRYSTALXBOW,
  PASSIVE_CD_RESET_Q,
  CROSSBOW_ARMORPIERCER,
  PASSIVE_ENERGYCHANCE_CROSSBOW,
  SUNDERSHOT,
  KNOCKBACKSHOT2,
  SNIPESHOT_CROSSBOW,
  SILENCINGBOLT,
  RENDINGSTRIKE,
  PASSIVE_KNUCKLE_BRAWLER,
  BOULDER_TOSS,
  PASSIVE_KNUCKLE_RAGE,
  AUTOFIRE2,
  TRIPLECOMBO_DIVEKICK,
  DASHKICK,
  BACKHAND_KNOCKBACK,
  KNUCKLECOMBO,
  PASSIVE_KNUCKLE_RUSHDOWN,
  PUMMELING_STRIKES,
  IMPULSE_PUNCH,
  MACELEAP,
  PASSIVE_KNUCKLE_COMBOBREAKER,
  CROSSSTEP_ROUNDHOUSE,
  DIVEPUNCH_RISE,
  THREATENINGSTRIKE_HAMMER,
  BLAZING_GEYSER,
  KNUCKLE_COUNTER,
  SHOCKWAVE_PUNCH,
  TRIPLE_KICK,
  CREATE_OPENING,
  HAMMERWHIRLWIND2,
  HAMMERTACKLE,
  GROUNDBREAKER2,
  CRYSTALWAVE,
  RAM_CHARGE,
  PASSIVE_ENERGYCHANCE_HAMMER,
  HAMMER_TREMOR,
  SPINNING_SMASH,
  GIANTSTEPS,
  PASSIVE_CCDURATION_CHANCE_HAMMER,
  IRONBREAKER,
  UNDEADHAND,
  HAMMER_SHOVE,
  KNOCKOUT,
  PASSIVE_HEALTHCHANCE_HAMMER,
  THREATENINGSMASH,
  GEYSER,
  PRIMALSLAM,
  CHARGE_ROOT,
  VACUUMSLASH,
  ROOTFIELD,
  CHARGESLOWAE,
  BLESSED_MACES,
  MACE_CRYSTAL_FRAGMENT_STORM,
  PASSIVE_STUNCHANCE,
  GUARDRUNE,
  SHRINKINGSMASH,
  SHRIEKMACE,
  PASSIVE_ENERGYCHANCE_MACE,
  AXEBOOST,
  PASSIVE_HEALTHCHANCE_MACE,
  PASSIVE_CCDURATION_CHANCE_MACE,
  PBAOE_PULL,
  GROUNDSHAKER,
  SACRED_GROUND,
  HAMSTRINGSWORD,
  LETHAL_CLEAVER,
  DEFENSIVESLAM,
  DUALAXE_CRAWLER,
  CRYSTAL_SCYTHE_DASH_ZONE,
  HEROICSTRIKE2,
  AXE_CHARGE,
  SCYTHESWING,
  BLADE_AURA,
  RENDINGSWING,
  SHOCKWAVE,
  AXETHROW,
  CLEAVE,
  CLAYMORESLASH,
  AXEWHIRLWIND2,
  PASSIVE_ARMORCHANCE_AXE,
  PASSIVE_SPELLPOWER_CHANCE_AXE,
  PASSIVE_HEALTHCHANCE_AXE,
  INNERBLEEDING,
  RENDINGCOMBO,
  AXESMASH,
  RENDINGSPIN,
  SWORD_BERSERK_RUN_RE,
  SHAPE_Q_CAST,
  MAJESTIC_SMASH,
  PARRY,
  BLADE_AREA,
  SHAPESHIFT_BEAR,
  MIGHTYSWING,
  MIGHTYBLOW,
  PASSIVE_REDUCE_DMG_SWORD,
  SPINATTACK,
  CLAYMORECHARGE,
  DEFENSERUN,
  PASSIVE_ARMORCHANCE_SWORD,
  PASSIVE_HEROICSTACK,
  INTERRUPT2,
  BRIEROFLIFE,
  SPLITTINGSLASH,
  THORNSAREA,
  SWORD_SPIN,
  SPIRITANIMAL,
  SOUL_LINK,
  ROTTENVINES,
  DUAL_NATURE,
  CLEANSEHEAL,
  NATURE_ULTIMATE_SINGLE,
  WELLOFLIFE2,
  QSWHIRLWIND,
  SHAPESHIFT_AVALONIAN_EAGLE,
  PASSIVE_MOVESPEED_CHANCE_NATURESTAFF,
  PASSIVE_ARMOR_CASTER_NATURESTAFF,
  PASSIVE_ENERGYCHANCE_NATURESTAFF,
  REJUVMUSHROOM_GRENADE,
  REJUVENATING_BREEZE,
  CIRCLEOFLIFE,
  REANIMATE,
  BRAMBLESEED,
  NATURERESILIENCE,
  SHAPESHIFT_IMP,
  SHAPESHIFT_WEREWOLF,
  REJUVENATION,
  CrystalCobraTransformation,
  ENERGYBURST_CHANNEL,
  SHAPESHIFT_ROCK_ELEMENTAL,
  SHAPESHIFT_ENT,
  SHAPE_W_POLYMORPH,
  SHAPE_W_TETHERBEAM,
  SHAPESHIFT_PANTHER,
  PASSIVE_SHAPESHIFT_W_CAST_SPEED_BUFF,
  TORNADO,
  SHAPE_W_AREA_PULL,
  PASSIVE_SHAPESHIFT_Q_CAST_DAMAGE_REDUCE,
  SHAPE_Q_CONE_MELEE,
  SHAPE_Q_SKILLSHOT,
  PASSIVE_SHAPESHIFT_GATHER_CHARGES,
  SKILLSHOT_TELEPORT,
  SHAPE_W_DAMAGE_AOE,
  QS_CRYSTAL_COMBO,
  COMBATSTAFF_SLASH,
  PASSIVE_SHAPESHIFT_ATTACK_BUFF,
  SHAPE_Q_DAMAGE_AND_SHIELD,
  SOULSHAKER,
  QS_SLOWROPE,
  RAPIERSTAB,
  DASH_KNOCKBACK,
  LANCE_CHARGE,
  TRIDENTTHROW,
  CONCUSSIVEBLOW_MULTI_1,
  WHIRLING_STAFF,
  CARTWHEEL,
  QSTAFF_COMBO,
  STUNRUN,
  QS_WHIRLWIND2,
  LAUNCHER,
  SEPARATING_SLAM,
  VAULT_ATTACK,
  PASSIVE_STUNCHANCE_QUARTERSTAFF,
  PASSIVE_ENERGYCHANCE_QUARTERSTAFF,
  PASSIVE_HEALTHCHANCE_QUARTERSTAFF,
  PASSIVE_CCDURATION_CHANCE_QUARTERSTAFF,
  SPEARTHROW,
  SKILLSHOT_PULL,
  TAINTED_STEEL,
  SHOVEL,
  HALBERDSMASH,
  PASSIVE_AASPEEDCHANCE_SPEAR,
  GHOSTSTRIKE,
  PASSIVE_SPELLPOWER_CHANCE_SPEAR,
  CRYSTAL_DAGGER_BLADE_RING,
  PASSIVE_HEALTHCHANCE_SPEAR,
  PASSIVE_KNOCKBACK_CASTER_HOLYSTAFF,
  DASHDMG,
  BACK_SLASH,
  GROUNDSPEAR,
  PASSIVE_BLEEDCHANCE,
  QDASH,
  LEGBREAKER,
  DEFLECTINGSTANCE,
  CHARGINGBLADE,
  FORESTOFSPEARS,
  DISEMBOWEL,
  SPIRITSPEAR,
  SPEAR_LUNGE,
  BLOOD_BLADE,
  FROST_TARGETED_CHANNEL,
  EXECUTEDAGGER,
  BLOODTHIRSTYBLADE,
  CHAINDASH,
  PASSIVE_SPELLPOWER_CHANCE_DAGGER,
  PASSIVE_AASPEEDCHANCE_DAGGER,
  PASSIVE_HEALTHCHANCE_DAGGER,
  THROWINGBLADES,
  GROUNDDASH,
  DARKMATTER,
  ASSASSINSPIRIT,
  DEEPCUTS,
  SUNDERARMOR2,
  AREAOFDECAY,
  CURSE_SKELETON_BARF_FDHR,
  CURSEULTIMATE,
  BURNINGARROWS,
  DEADLYSHOT,
  GROUNDARROW,
  AIR_RAID,
  ARROWRAIN,
  HAWK_SHOT_MULTI1,
  HELL_ARROW,
  LIGHTNING_ARROW,
  PASSIVE_AASPEEDCHANCE_BOW,
  SKILLSHOT_STUN,
  UNDEADARROWS,
  SPEEDSHOT2,

  JUMPSHOT2,
  MULTISHOT2,
  PASSIVE_ARMOR_PIERCE_STACK,
  PASSIVE_ENERGYCHANCE_BOW,
  PASSIVE_SLOWPOISON,
  POISONARROW,
  SPEEDARCHER_KITE,

  DYNAMIC_CURSE,
  ENFEEBLEBLADES,
  CURSED_WALL,
  SKULLCURSE,

  DEATHCURSE2,
  CURSED_SPLAT,
  CURSEBLADE,
  CURSEDOT,

  PASSIVE_CURSE,
  PASSIVE_ENERGYCHANCE_CURSEDSTAFF,
  PASSIVE_MOVESPEED_CHANCE_CURSEDSTAFF,
  PASSIVE_SPELLPOWER_CASTER_CURSEDSTAFF,
  ARMORPIERCER,
  CURSEDBEAM,
  CURSEDHANDS_STACKUP,
  CURSENOVA,

  FROST_ULTIMATE,
  FROSTBEAM,
  FROSTBOMB_CASTSLOW,
  FROSTNOVA,
  PASSIVE_CASTINGSPEED_CHANCE_FROSTSTAFF,
  PASSIVE_ENERGYCHANCE_FROSTSTAFF,
  PASSIVE_FROST,
  FROZEN_CRYSTAL,
  GLACIALFIELD,
  ICEROCK_EXPLODE,
  ARCANE_CHAIN_MISSILE,
  CLEANSESPEED2,
  FREEZINGWIND,
  FROST_BITE,
  FROST_LANCE,
  HAIL_MULTI_1,
  ICE_SCULPTURE,
  ICESHARD,
  ICESTORM2,
  PASSIVE_SPELLPOWER_CASTER_FROSTSTAFF,
  SHATTER_Q,
  ENIGMA_BLADE,
  MAGICSHOCK,
  SHIELDFRIENDLY,
  FIREPHOENIX,
  RESURRECTION,
  HOLY_DISPEL,
  HOLYSHIELD,
  ARCANEORB2,
  EMPOWERBEAM,
  FRAZZLE2,
  MIMIC,
  PASSIVE_ATTACKBUFF_ARCANESTAFF,
  PASSIVE_ENERGYCHANCE_ARCANESTAFF,
  HOLY_ULTIMATE,
  DIVINE_JUMP,
  HOLYEXPLOSION,
  ARCANE_METEOR,
  ARCANECORRIDOR,
  BLACKHOLE,
  INVULNERABILITY,
  PASSIVE_ARMOR_CASTER_ARCANESTAFF,
  PASSIVE_SILENCECHANCE,
  STARFALL_DOT,
  TIME_FREEZE,
  VOID,
  HOLYTOUCH,
  CELESTIAL_SPHERE,
  HOLYDESPERATEPRAYER2,
  FLAMEDASH,
  PASSIVE_ENERGYCHANCE_HOLYSTAFF,
  METEOR,
  SMITE_AOE,
  PASSIVE_HEALPOWERCHANCE,
  WallofFlames,
  GENEROUSHEAL,
  PULSINGHEAL,
  MAGMASPHERE,
  PASSIVE_HOLY_ASCENDED,
  FLAMEPILLAR,
  HUMAN_TORCH,
  HOLYFLASH,
  HEALINGBEAM,
  RagingFlare,
  HOLYORB,
  JUMP,
  FLAMETORNADO,
  HOLYHOT,
  SearingFlame,
  Fire_Bolt,
  PASSIVE_ENERGYCHANCE_FIRESTAFF,
  ASSASSIN_DASH,
  FireWave,
  CC_BLOCK,
  FlameBlast,
  CHARGE_IN,
  Pyroblast,
  PASSIVE_BURN,
  BurningField,
  FireArtillery,
  PASSIVE_CASTINGSPEED_CHANCE_FIRESTAFF,
  CHARGE_SHIELD,
  PASSIVE_INCREASED_DAMAGE,
  PASSIVE_SPELLPOWER_CASTER_FIRESTAFF,
  Perpetual_energy,
  BERSERK_SPRINT,
  MAXHEALTHBUFF,
  ROYAL_MARCH,
  SHOULDERTACKLE,
  WANDERLUST,
  BATTLEFRENZY,
  Rejuvenating_Sprint,
  SWAP,
  INVISIBLE_WALK,
  DMG_BLINK,
  DEMONWALK,
  DODGE,
  DEATHMARK,
  TRANSLUCENT,
  OVERSPRINT,
  CLEANSE_DASH,
  SPRINT_CD_REDUCTION,
  HOVER_SPRINT,
  PASSIVE_MAXLOAD_SHOES,
  GLASS_MOVESPEED,
  nasty_wounds,
  BLINK,
  BLINDSPOT,
  AFTER_IMAGE,
  CHANNELED_RUN,
  FROSTWALK,
  PASSIVE_INCREASED_CCR,
  MANADRAIN,
  SPRINTEOT,
  REFLECT_CHANNEL,
  DELAYED_TELEPORT,
  FORCESHIELD,
  ARMOR_WEB,
  REFLECTAREA,
  ENFEEBLEAURA,
  WINDWALL,
  ARMORCHAIN,
  PASSIVE_PLATEARMOR_HEALTH_REDUCTION,
  PASSIVE_PLATEARMOR_THREATGENERATION,
  Immortal,
  PASSIVE_CCDURATION,
  spiders_thread,
  PASSIVE_MR_AR,
  Taunt,
  ENRAGE,
  emergency_shield,
  purifying_smoke,
  electric_discharge,
  Howl,
  flash_of_insight,
  ballista_support_fire,
  smokebomb,
  Quick_thinker,
  sacrifice,
  WEAPON_SILENCE,
  mortal_agony,
  Growing_rage,
  displacement_immunity,

  Retaliate,
  Efficiency,
  Swiftness,
  Inner_Corruption,
  Avalonian_beam,
  Hyper_Focus,
  Balanced_Mind,
  Firebreath,
  Purge,
  ENERGYFIELD,
  ENERGYSHIELD,
  Ice_block,
  Concentration,
  PASSIVE_CASTSPEED,
  aggression,
  SELF_CLEANSE,
  GROWING_RAGE,
  PASSIVE_BALANCE,
  PASSIVE_INCREASED_AASPEED,
  PASSIVE_CD_REDUCTION,
  ENERGIZING_SHIELD,
  force_field,
  stone_skin,
  block,
  toughness,
  authority,
  tenacity,

  OUTOFCOMBATHEAL,
  Frost_Shield,
  Speed_Caster,
  Everlasting_Spirit,
  Purging_Shield,
  Magic_Rune,
  Obsessive_Burst,
  Fear_Aura,
  Levitate,
  Wild_Magic,
  Energy_Emission,

  Bloodlust,
  FLAMESHIELD,
  HASTE,
  Ambush,
  Royal_Banner,
  STORMSHIELD,
  Life_Steal_Aura,
  BURNAURA,
  MIST_WALKER,
  Dynamic_Defense,
};

export default spellIcons;
